import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  position: relative;
  padding-top: 15px;

  .buttons-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    gap: 8px;
  }
`

export const iconButton: Interpolation<Theme> = css`
  &.MuiButtonBase-root {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`
